import Cookies from 'js-cookie';
import {baseUrl, execute, fetchWithRetry} from "./ApiUtils";

const baseGameUrl = baseUrl + "game/"
const baseGroupGameUrl = baseUrl + "groupgame/"
const postLoginDataUrl = baseUrl + "token/";
const postCreateGameUrl = baseUrl + "game";
const getCreatedGamesUrl = baseUrl + "game";
const getCurrentGameUrl = baseGameUrl;
const postDiceMoveUrl = baseGameUrl;
const getMentorCardsByUuidUrl = baseGameUrl
const getCardDescriptionUrl = baseGameUrl
const getNewTokenUrl = baseUrl + "token/refresh/";
const validateLoginUrl = baseUrl + "validate_login/";
const logoutUrl = baseUrl + "logout/";
const postCommentUrl = baseUrl + "step/";
const deleteLastMoveUrl = baseGameUrl;
const verifyEmailUrl = baseUrl + "verify_email/";
const updateGameDataUrl = baseGameUrl;
const resetPasswordUrl = baseUrl + "reset_password";
const setPasswordUrl = baseUrl + "set_password";
const postCombinationUrl = baseUrl + "mentor_sequence";
const putCombinationUrl = baseUrl + "mentor_sequence/";
const getCombinationsUrl = baseUrl + "mentor_sequence";
const convertTrialGameToRegularUrl = baseGameUrl
const continueEndedGame = baseGameUrl;
const postUserRequestUrl = baseGameUrl;
const getProfileRequestUrl = baseUrl + "mymentorprofile";
const changePasswordUrl = baseUrl + "change_password";
const registerUrl = baseUrl + "register/";
const mentorReferralCodeUrl = baseUrl + "mentor_referral_code";
const zoomAuthEndpoint = baseGameUrl;
const awsPresignedS3RequestUrl = baseGameUrl;
const recordingStartedUpdateUrl = baseGameUrl;
const availableGameFieldStylesUrl = baseUrl + "available_styles";
const availableCardDecksUrl = baseUrl + "available_decks";
const paymentsCheckoutSessionUrl = baseUrl + "payments/checkout_session";
const mentorsRating = baseUrl + "top_active_mentors"
const mentors = baseUrl + "mentors"
const mentorPhotoUploadGetPresignedUrl = baseUrl + "users/presigned_mentor_photo_upload_request"
const mentorPhoneNumberUrl = baseUrl + "users/mentor_phone_number"
const mentorPhoneNumberVerificationUrl = baseUrl + "users/mentor_phone_number_verification"
const userSettingsUrl = baseUrl + "users/settings"
const nextAdUrl = baseUrl + "advertisement/next_ad"
const traceClickUrl = baseUrl + "advertisement/ad_click"
const dismissRefBonusUrl = baseUrl + "users/dusmiss_reference_benefit"
const favoriteFieldsUrl = baseUrl + "users/favourite_field"



let gameId = "game_id"

function checkDoubleUser(email) {
    const previousUsers = localStorage.getItem("loulog")
    if (previousUsers) {
        let previousUsersList = JSON.parse(previousUsers)
        if (previousUsersList.length > 0) {

            if (!previousUsersList.includes(btoa(email))) {
                let prevUsersString = ""
                for (const prevUser of previousUsersList) {
                    prevUsersString += atob(prevUser)
                    prevUsersString += " "
                }
                console.error("Multiple users login " + prevUsersString + email)
            }
            
        }
        if (!previousUsersList.includes(btoa(email))) {
            previousUsersList.push(btoa(email))
        }
        localStorage.setItem("loulog", JSON.stringify(previousUsersList))
    } else {
        let previousUsersList = [btoa(email)]
        localStorage.setItem("loulog", JSON.stringify(previousUsersList))
    }
}

export function postLoginData(email, pass, redirect, redirectNotAuth) {
    fetch(postLoginDataUrl, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email: email.trim(),
            password: pass,
        }),
        credentials: "include"

    }).then(r => {
        if (r.ok) {
            try {
                checkDoubleUser(email.trim())
            } catch (e) {
                console.error("failed to check double users for email ", email, e)
            }
            const res = r.json()
            res.then(r => {
                redirect()
            })
        } else {
            redirectNotAuth()
        }
    })
        .catch(error => console.error(error))
}

export function postCreateGame(
    playerName,
    isAutoDice,
    gameName,
    isTrial,
    videoAllowed,
    selectedStyle,
    isSelfGame,
    price,
    deckId,
    deckType,
    executeOnSuccess,
    redirectOnError) {
    execute(() =>
        fetch(postCreateGameUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: gameName,
                player_name: playerName,
                is_auto_dice: isAutoDice,
                is_trial_game: isTrial,
                video_allowed: videoAllowed,
                game_field_style_id: selectedStyle,
                is_self_game: isSelfGame,
                price: price,
                deck_id: deckId,
                deck_type: deckType,
            }),
            credentials: "include"
        }), executeOnSuccess, redirectOnError)
}

export function postUpdateGame(
    gameId,
    playerName,
    isAutoDice,
    gameName,
    selectedStyle,
    deckId,
    deckType,
    executeOnSuccess,
    redirectOnError) {
    execute(() =>
        fetch(updateGameDataUrl + gameId, {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: gameName,
                player_name: playerName,
                is_auto_dice: isAutoDice,
                game_field_style_id: selectedStyle,
                deck_id: deckId,
                deck_type: deckType,
            }),
            credentials: "include"
        }), executeOnSuccess, redirectOnError)
}

export function deleteGame(gameId, executeOnSuccess, errorRedirect) {
    execute(() => fetch(baseGameUrl + gameId, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function getCreatedGamesForUser(setGameState, errorRedirect) {
    execute(() =>
        fetch(getCreatedGamesUrl, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), setGameState, errorRedirect)
}

export function getCurrentGame(id, successCallBack, errorRedirect) {
    Cookies.set(gameId, id)
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }

    execute(() => fetch(getCurrentGameUrl + id, {
        method: 'GET',
        headers: headers,
        credentials: "include"
    }), successCallBack, errorRedirect)
}

export function getCurrentGameStyle(id, successCallBack, errorRedirect) {
    execute(() => fetch(getCurrentGameUrl + id + "/field_style", {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }), successCallBack, errorRedirect)
}

export function postDiceMove(diceNum, executeOnSuccess, errorRedirect) {
    execute(() => fetch(postDiceMoveUrl + Cookies.get(gameId) + "/move", {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            dice_num: diceNum,
        }),
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function getAllMentorCardsByGameId(gameId, executeOnSuccess, errorRedirect) {
    execute(() => fetch(getMentorCardsByUuidUrl + gameId + "/card", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function getCardDescription(gameId, cellNumber, executeOnSuccess, errorRedirect) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
    execute(() => fetch(getCardDescriptionUrl + gameId + "/card/" + cellNumber, {
        method: 'GET',
        headers: headers,
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function postStepComment(stepId, text, executeOnSuccess, errorRedirect) {
    execute(() => fetch(postCommentUrl + stepId + "/comment", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            text: text,
        }),
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function postPlayerRequest(game_id, user_request_text, executeOnSuccess, errorRedirect) {
    execute(() => fetch(postUserRequestUrl + game_id + "/user_request", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            user_request: user_request_text,
        }),
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function deleteLastMove(gameId, executeOnSuccess, errorRedirect) {
    execute(() => fetch(deleteLastMoveUrl + gameId + "/last_step", {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function deleteLastPendingMove(gameId, executeOnSuccess, errorRedirect) {
    execute(() => fetch(deleteLastMoveUrl + gameId + "/last_step?pending_move=true", {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function resetPassword(email, executeOnSuccess, errorRedirect) {
    execute(() => fetch(resetPasswordUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email: email.trim(),
        }),
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function setPassword(password, token, executeOnSuccess, errorRedirect) {
    execute(() => fetch(setPasswordUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            new_password: password,
            token: token
        }),
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function createNewCombination(steps, description, executeOnSuccess, errorRedirect) {
    execute(() => fetch(postCombinationUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sequence: steps,
            text: description
        }),
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function updateCombination(combinationId, steps, description, executeOnSuccess, errorRedirect) {
    execute(() => fetch(putCombinationUrl + combinationId, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sequence: steps,
            text: description
        }),
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function deleteCombination(combinationId, executeOnSuccess, errorRedirect) {
    execute(() => fetch(putCombinationUrl + combinationId, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function getCombinations(executeOnSuccess, errorRedirect) {
    execute(() => fetch(getCombinationsUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), executeOnSuccess, errorRedirect)
}

export function register(email, pass, nickname, referral_code, language, executeOnSuccess, errorRedirect) {
    execute(() => fetch(registerUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email: email.trim(),
            password: pass,
            nickname: nickname,
            referral_code: referral_code,
            language: language
        }),
    }), executeOnSuccess, errorRedirect)
}

export function refreshTokenAndRetry(request, callback, errorRedirrect) {
    fetch(getNewTokenUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }).then(refreshResponse => {
        if (refreshResponse.ok) {
            request().then(requestResponse => {
                if (requestResponse.ok) {
                    const contentType = requestResponse.headers.get('content-type');
                    if (contentType && contentType.includes('application/json')) {
                        requestResponse.json().then(json => callback(json))
                    } else {
                        callback(requestResponse)
                    }

                } else {
                    logout(errorRedirrect)
                }

            })
        } else {
            logout(errorRedirrect)
        }
    })
        .catch(error => {
            console.error(error)
        })
}

export function verifyLogin(callback) {
    fetch(validateLoginUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }
    ).then(response => {
            if (response.ok) {
                callback(true)
            } else {
                callback(false)
            }
        }
    ).catch((error) => {
        console.error("verifyLogin API call error " + error)
        callback(false)
    })
}

export function logout(callback) {
    fetch(logoutUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }
    ).then((r) => {
        callback(r)
    })
}

export function callVerifyEmail(token, callback, error) {
    fetch(verifyEmailUrl + token, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (response.ok) {
            callback()
        } else {
            error()
        }
    })
}

export function callConvertTrialGameToRegular(game_id, perserveHistory, callback, error) {
    execute(
        () => fetch(convertTrialGameToRegularUrl + game_id + "/convert_trial", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                preserve_history: perserveHistory
            }),
            credentials: "include"
        }), callback, error
    )
}

export function callContinueEndedGame(game_id, callback, error) {
    execute(
        () => fetch(continueEndedGame + game_id + "/continue_ended", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}

export function fetchMentorProfile(callback, error) {
    execute(
        () => fetch(getProfileRequestUrl, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}

export function saveMentorProfile(nickName, short_bio, long_bio, photoUrl, social_url, callback, error) {
    execute(
        () => fetch(getProfileRequestUrl, {
            method: "PATCH",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                nickname: nickName,
                short_bio: short_bio,
                long_bio: long_bio,
                photo_url: photoUrl,
                social_url: social_url

            }),
            credentials: "include"
        }), callback, error
    )
}

export function changePassword(oldPassword, newPassword, callback, error) {
    execute(
        () => fetch(changePasswordUrl, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                old_password: oldPassword,
                new_password: newPassword,
            }),
            credentials: "include"
        }), callback, error
    )
}

export function fetchReferralData(callback, error) {
    execute(
        () => fetch(mentorReferralCodeUrl, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}

export function requestReferralCode(callback, error) {
    execute(
        () => fetch(mentorReferralCodeUrl, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}


export function getZoomAuthToken(game_id, callback, error) {
    execute(
        () => fetch(zoomAuthEndpoint + game_id + "/zoomauthtoken", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}

export function getPresignedS3Request(game_id, callback, error) {
    execute(
        () => fetch(awsPresignedS3RequestUrl + game_id + "/presigneduploadrequest", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }), callback, () => error("API call failed")
    )
}

export function sendRecordingStartedUpdate(gameId, callback, error) {
    execute(
        () => fetch(recordingStartedUpdateUrl + gameId + "/recording_started", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        }), callback, error)
}


export function processGameRecordings(game_id, callback, error) {
    execute(() => fetch(baseGameUrl + game_id + "/processrecordings", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include",
        }), callback, error
    )
}

export function processGroupGameRecordings(game_id, callback, error) {
    execute(() => fetch(baseGroupGameUrl + game_id + "/processrecordings", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include",
    }),callback, error)
}

export function getProcessedRecordings(game_id, callback, error) {
    execute(() => fetch(baseGameUrl + game_id + "/recordings", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include",
    }), callback, error)
}

export function getGroupGameProcessedRecordings(game_id, callback, error) {
    execute(() => fetch(baseGroupGameUrl + game_id + "/recordings", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include",
    }), callback, error)
}

export function getAvailableGameFieldStyles(callback, error) {
    execute(
        () => fetch(availableGameFieldStylesUrl, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}

export function getAvailableCardDecks(callback, error) {
    execute(
        () => fetch(availableCardDecksUrl, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}

export function getAvailableCardDecksForFieldStyle(callback, error, gameField_Id) {
    execute(
        () => fetch(availableCardDecksUrl + "?game_field_id=" + gameField_Id, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), callback, error
    )
}


export function saveSelectedMetaphoricCard(gameId, deck, card, imageUrl, callback, error) {
    execute(
        () => fetch(baseGameUrl + gameId + "/metaphoric_card", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                deck: deck,
                card: card,
                image_url: imageUrl,
            }),
            credentials: "include"
        }), callback, error
    )
}

export function getPaymentResult(sessionId, successCallBack, errorCallBack) {
    execute(
        () => fetch(paymentsCheckoutSessionUrl + "?session_id=" + sessionId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), successCallBack, errorCallBack
    )
}

export function createCheckoutSession(topUpAmount, successCallBack, errorCallBack) {
    execute(
        () => fetch(paymentsCheckoutSessionUrl, {
                method: "POST",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({bundle_id: "coin_" + topUpAmount}),
                credentials: "include"
            }
        ), successCallBack, errorCallBack
    )
}

export function getMentorsRating(successCallBack, errorCallBack) {
    execute(() => fetch(mentorsRating, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function getMentors(successCallBack, errorCallBack) {
    execute(() => fetch(mentors, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function getMentorPhotoUploadPresignedUrl(extension, successCallBack, errorCallBack) {
    fetch(mentorPhotoUploadGetPresignedUrl + "?extension=" + extension, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }).then(response => {
        if (response.ok) {
            response.json().then(
                r => successCallBack(r)
            ).catch(e => errorCallBack("failed to parse response" + JSON.stringify(e)))
        } else {
            errorCallBack("API call failed")
        }
    })
}

export function getLiveKitToken(gameId, successCallBack, errorCallBack) {
    execute(() => fetch(baseGameUrl + gameId + "/livekitauthtoken", {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function changeVideoType(gameId, successCallBack, errorCallBack) {
    execute(() => fetch(baseGameUrl + gameId + "/changevideotype", {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        credentials: "include"
    }), successCallBack, errorCallBack)
}
export function getCurrentMentorPhoneNumber(successCallBack, errorCallBack) {
    execute(() => fetch(mentorPhoneNumberUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function postMentorPhoneNumber(phoneNumber, successCallBack, errorCallBack) {
    execute(() => fetch(mentorPhoneNumberUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({phone_number: phoneNumber}),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function requestSendVerificationSMS(successCallBack, errorCallBack) {
    execute(() => fetch(mentorPhoneNumberVerificationUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function submitVerificationSMS(token, successCallBack, errorCallBack) {
    execute(() => fetch(mentorPhoneNumberVerificationUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({token: token}),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function getUserSettings(successCallBack, errorCallBack) {
    execute(() => fetch(userSettingsUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}
export function saveUserSettings(
    on6move,
    on66xWithArrows,
    on6666xWithArrows,
    highlightSteps,
    allowAllFieldsView,
    successCallBack,
    errorCallBack) {
    execute(() => fetch(userSettingsUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            game_behaviour_at_6: on6move ? "move" : "accumulate",
            game_behaviour_at_6x_or_66x: !on6move && !on66xWithArrows ? "move_by_sum" : "move_with_snakes_and_arrows",
            game_behaviour_at_6666x_or_more: !on6move && !on6666xWithArrows ? "move_by_sum" : "move_with_snakes_and_arrows",
            game_view_highlight_steps: highlightSteps,
            game_view_enable_view_all_cells: allowAllFieldsView,
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function getAdToShow(successCallBack, errorCallBack) {
    execute(() => fetch(nextAdUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function traceAdClick(adId, successCallBack, errorCallBack) {
    execute(() => fetch(traceClickUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            "ad_id": adId
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}


export function addCustomMove(gameId, toPosition, successCallBack, errorCallBack) {
    execute(() => fetch(baseGameUrl + gameId + "/custom_move", {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            "to_position": toPosition
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function dismissRefBonus(successCallBack, errorCallBack) {
    execute(
        () => fetch(dismissRefBonusUrl, {
            method: "POST",
            headers: {'Content-Type': 'application/json'},
            credentials: "include"
        }),
        successCallBack, errorCallBack)
}

export function favoriteFields(action, field_id, successCallBack, errorCallBack) {
    execute(
        () => fetch(favoriteFieldsUrl, {
            method: "POST",
            headers: {'Content-Type': 'application/json'},
            credentials: "include",
            body: JSON.stringify({
                "action": action,
                "field_id": field_id
            }),
        }),

        successCallBack, errorCallBack)
}